import React from 'react';
import CloseOutlined from '@material-ui/icons/CloseOutlined';

export default function CloseOutlinedIcon() {

    return (
        <CloseOutlined />
    );
}